/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wild_Jade_Hawk_SoarInputs */

const en_wild_jade_hawk_soar = /** @type {(inputs: Wild_Jade_Hawk_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment Access`)
};

const de_wild_jade_hawk_soar = /** @type {(inputs: Wild_Jade_Hawk_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmentzugriff`)
};

/**
* | output |
* | --- |
* | "Segment Access" |
*
* @param {Wild_Jade_Hawk_SoarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wild_jade_hawk_soar = /** @type {((inputs?: Wild_Jade_Hawk_SoarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wild_Jade_Hawk_SoarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wild_jade_hawk_soar(inputs)
	return de_wild_jade_hawk_soar(inputs)
});